export const svg_mobile_transparent_105_by_105 = `data:image/svg+xml;utf8,${encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" width="105" height="105" viewBox="0 0 105 105">
</svg>
`)}`;
export const svg_mobile_transparent_bordered_600_by_300 = `data:image/svg+xml;utf8,${encodeURIComponent(`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="600"
    height="300"
    viewBox="0 0 600 300"
    style="background: transparent;"
  >
    <rect
      x="0"
      y="0"
      width="600"
      height="300"
      fill="none"
      stroke="black" 
      stroke-width="1"
    />
  </svg>
  `)}`;
export const svg_mobile_transparent_600_by_300 = `data:image/svg+xml;utf8,${encodeURIComponent(`
<svg
  xmlns="http://www.w3.org/2000/svg"
  width="600"
  height="300"
  viewBox="0 0 600 300"
  style="background: transparent;"
>
  <rect
    x="0"
    y="0"
    width="600"
    height="300"
    fill="none"
  />
</svg>
`)}`;
export const svg_slider_auto_by_300 = {
  'mobile': `data:image/svg+xml;utf8,${encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="300" viewBox="0 0 600 300" style="background: transparent;">
     <rect
        x="0"
        y="0"
        width="600"
        height="300"
        fill="none"
    />
  </svg>
    `)}`,
  'desktop': `data:image/svg+xml;utf8,${encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="300" viewBox="0 0 600 300" style="background: transparent;">
     <rect
        x="0"
        y="0"
        width="600"
        height="300"
        fill="none"
    />
  </svg>
    `)}`
};